/**
 * Navigation constants shared across layout components
 */

import {
  Bookmark,
  Film,
  Globe2,
  GraduationCap,
  History,
  Home,
  Layers,
  PlayCircle,
  Rss,
  Users,
} from 'lucide-react';
import { TourAnchor, type TourAnchorId } from '@/shared/lib/tours/anchors';

export interface NavigationItem {
  name: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  /** Feature-tour target (`data-tour`). */
  tourAnchor?: TourAnchorId;
}

export const mainNavigation: NavigationItem[] = [
  { name: 'Home', href: '/', icon: Home },
  { name: 'Shorts', href: '/shorts', icon: PlayCircle, tourAnchor: TourAnchor.NAV_SHORTS },
  { name: 'Videos', href: '/videos', icon: Film },
  { name: 'Series', href: '/series', icon: Layers },
  { name: 'Edu', href: '/courses', icon: GraduationCap },
  { name: 'Feed', href: '/community', icon: Rss },
  { name: 'Creators', href: '/creators', icon: Users, tourAnchor: TourAnchor.NAV_CREATORS },
  { name: 'Globe', href: '/globe', icon: Globe2, tourAnchor: TourAnchor.NAV_GLOBE },
];

export const userNavigation: NavigationItem[] = [
  { name: 'History', href: '/profile?tab=history', icon: History },
  { name: 'Watchlist', href: '/watchlist', icon: Bookmark, tourAnchor: TourAnchor.NAV_WATCHLIST },
];
